import React, { useMemo, useState } from "react";
import { motion } from "framer-motion";

// Rating Scale Component
const RatingScale = ({ onRatingSelect, selectedRating }) => {
  const [localHovered, setLocalHovered] = useState(null);
  const isHoverCapable = useMemo(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }, []);

  return (
    <div className="space-y-8">
      <p className="text-white/80">How satisfied are you?</p>

      <div className="flex justify-center items-center">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating, index) => (
          <motion.button
            key={rating}
            onClick={(e) => {
              // avoid sticky focus on mobile
              if (e.currentTarget && e.currentTarget.blur)
                e.currentTarget.blur();
              onRatingSelect(rating);
            }}
            onMouseEnter={
              isHoverCapable ? () => setLocalHovered(rating) : undefined
            }
            onMouseLeave={
              isHoverCapable ? () => setLocalHovered(null) : undefined
            }
            className={`
              w-10 h-12 font-bold text-base transition-all duration-200 flex items-center justify-center
              ${
                index === 0 ? "rounded-l-lg" : index === 9 ? "rounded-r-lg" : ""
              }
              ${
                selectedRating === rating
                  ? "bg-[#dcff02] text-black border-[#dcff02]"
                  : isHoverCapable && localHovered && rating <= localHovered
                  ? "bg-[#dcff02]/30 text-[#dcff02] border-[#dcff02]"
                  : "bg-black/40 text-white/60 border-white/20"
              }
              border-r border-t border-b ${index === 0 ? "border-l" : ""}
            `}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {rating}
          </motion.button>
        ))}
      </div>

      <div className="flex justify-between text-xs text-white/40 max-w-xs mx-auto">
        <span>Poor</span>
        <span>Excellent</span>
      </div>
    </div>
  );
};

export default RatingScale;
